/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaInputDatePicker from 'DesignSystem/TysiaInput/TysiaInputDatePicker/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  closePopover,
  viewPath = "/DesignSystem/ManualAutomations/Content/Content/ActiveAction/CreateProcedureReceivables/Content/Content/Invoice/Content/DueDate/Content"
  
}) {
let invoiceDueDateValueData = fromData.useDataValue({ viewPath,
context: 'invoice',
path: 'due_date',
})
let onChange = fromHelpers.useOnChange({
  children,
  closePopover,
  viewPath
  
})
  return (<React.Fragment
>
<TysiaInputDatePicker
  viewPath={`${viewPath}/TysiaInputDatePicker`}
 data="invoice.due_date"
 value={invoiceDueDateValueData}
 onChange={onChange}
/>
{children}
</React.Fragment>)
}